import React from 'react';
import T from 'prop-types';
import { isEmpty, intersection } from 'lodash-es';

import DateRange from './DateRange';
import SearchEntities from './SearchEntities';
import ExportSettings from './ExportSettings';
import PanelVersionDropdown from './PanelVersionDropdown';
import DataTypeSwitcher from '../DataTypeSwitcher';
import Container from '../../../Container';

import { ADVANCED_METRICS_V2_MAP, V2_COHORTS_MAP } from '../../../../utils/advanced-metrics';
import { DATA_TYPE } from '../../configs/constants';

const UpsertExportForm = ({
  initParams = {},
  formMode,
  dataType,
  report = {},
  autoFocus,
  formActions,
  prefetchingEntities,
  onReset,
  onPrefill,
  onChange,
  onChangeDataType,
}) => {
  const handlePanelsVersionChange = (newVersion) => {
    onChange({
      ...report,
      data_points: intersection(report.data_points, ADVANCED_METRICS_V2_MAP[newVersion]),
      user_segments: intersection(report.user_segments, V2_COHORTS_MAP[newVersion]),
      panel_version: newVersion,
    });
  };

  const { permissions } = initParams;

  return (
    <section className="upsert-export-form">
      <Container maxWidth={870}>

        {(permissions?.allowAdvancedMetricsExport || permissions?.allowMpi) && (
          <DataTypeSwitcher
            value={dataType}
            dataType={dataType}
            report={report}
            onChange={onChangeDataType}
          />
        )}

        {dataType === DATA_TYPE.ADVANCED && permissions.allowPanelsVersionSwitcher && (
          <PanelVersionDropdown
            panelVersion={report.panel_version}
            onChange={handlePanelsVersionChange}
          />
        )}

        <SearchEntities
          initParams={initParams}
          formMode={formMode}
          dataType={dataType}
          report={report}
          autoFocus={autoFocus}
          prefetchingEntities={prefetchingEntities}
          onReset={onReset}
          onReportChange={onChange}
        />
        <DateRange
          initParams={initParams}
          dataType={dataType}
          report={report}
          disabled={isEmpty(report.reportEntities)}
          onReportChange={onChange}
        />
        <ExportSettings
          dataType={dataType}
          report={report}
          onReportChange={onChange}
          onPrefill={onPrefill}
        />
        <div className="upsert-export-form__buttons">
          {formActions}
        </div>
      </Container>
    </section>
  );
};

UpsertExportForm.propTypes = {
  initParams: T.object.isRequired,
  formMode: T.object.isRequired,
  dataType: T.string.isRequired,
  report: T.object.isRequired,
  autoFocus: T.bool,
  formActions: T.node,
  prefetchingEntities: T.bool,
  onReset: T.func.isRequired,
  onPrefill: T.func.isRequired,
  onChange: T.func.isRequired,
  onChangeDataType: T.func.isRequired,
};

export default UpsertExportForm;
